import request from '@/utils/request2'

// 列表(主数据列表)
export function loadPriceRangeSettingListDataApi(data) {
  return request({
    url: 'tms-web/priceRangeSetting/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportPriceRangeSettingListDataApi(data) {
  return request({
    url: 'tms-web/priceRangeSetting/exportByPage',
    method: 'post',
    data
  })
}

// 保存
export function savePriceRangeSettingApi(data) {
  return request({
    url: 'tms-web/priceRangeSetting/save',
    method: 'post',
    data
  })
}

// 变更状态
export function updatePriceRangeSettingStatusApi(data) {
  return request({
    url: 'tms-web/priceRangeSetting/updateStatus',
    method: 'post',
    data
  })
}

// 作废
export function deletePriceRangeSettingApi(data) {
  return request({
    url: 'tms-web/priceRangeSetting/delete',
    method: 'post',
    data
  })
}

// 查看
export function viewPriceRangeSettingApi(data) {
  return request({
    url: 'tms-web/priceRangeSetting/view',
    method: 'post',
    data
  })
}

// 列表
export function listPriceRangeSettingApi(data) {
  return request({
    url: 'tms-web/priceRangeSetting/list',
    method: 'post',
    data
  })
}
